import type { CallbackFunction } from '@docoi/jsbridge-sdk/types';
import { getParamsByUrl } from './url';
import { isInDocoiApp, isInWebCommunity, isMiniProgram } from './app';
import { isIOS } from './device';
import { getSessionStorage, getStorage } from './storage';
import { useLogin } from '../composables/useLogin';
import JSBridge from '../bridge';
import { JSBridgePageType } from '@/bridge/types';

/**
 *
 * @param params {page?: number, params?: any}
 * page:
 *1：首页 (v3.7.0 新增params参数：{ tab:0|1|2|3，dynamicData:any },tab：0,1,2,3分别对应首页，发现页，消息，我的；dynamicData：tab为1时有效)
 *2：好友tab
 *3：消息tab好友列表
 *4：跳转装扮
 *5：充值页面
 *6：跳转首页并拉起动态模块
 *7：动态发布页面，server_id必传，params中如果有携带channel_id,则自动选择该频道
 *8：梦游岛场景
 *9：派对Tab
 *10：资料编辑页
 *11：用于ios 做统一的页面跳转，params:{url:string}
 *12：动态发布页面，跳转至对应的聊天室的聊天界面，params中需传参数 group_id(必传)  server_id（服务器id，非必传） channel_id（频道id，非必传）
 *13：用户主页，params中需传参数 uid(必传) [用户id]
 *14：打开圈子首页 params中需传参数 serverId(必传)
 *15：跳到抖音商城
 *16: 跳转到广告页 params中需传参数 url(必传)
 * @param callback
 */
export const h5RedirectPage = (
	params: {
		page: JSBridgePageType;
		params?: any;
	},
	callback?: CallbackFunction
) => {
	return redirectPage(params, callback);
};

/**
 * 根据URL Scheme打开APP中的页面
 * @param url daoke://page开头的URL Scheme
 * @returns
 */
export const h5OpenAppPage = (url?: DaokeUrlSchemeType) => {
	if (!url) return;
	if (isInDocoiApp()) {
		let params = getParamsByUrl(url);
		// 优先打开外部浏览器
		if (params?.isOpenInExternalBrowser) {
			JSBridge.call('openInExternalBrowser', { url: params.url });
		} else {
			if (isIOS) {
				h5RedirectPage({ page: 11, params: { url } });
			} else {
				setH5BeforeInfo();
				window.location.href = url;
			}
		}
	} else {
		window.location.href = url;
	}
};

const COMMUNITY_TOKEN_STORAGE_KEY = 'communityToken';
/** 内嵌页把拉起 App 交给 community 壳的消息 type */
export const COMMUNITY_OPEN_APP_MESSAGE = 'community-open-app';

const getTokenValue = (storageKey: string): string => {
	try {
		const value = getStorage(storageKey);
		if (!value) return '';
		const parsed = JSON.parse(value) as { token?: string; visitor_token?: string; is_visitor?: boolean };
		if (storageKey === COMMUNITY_TOKEN_STORAGE_KEY && parsed.is_visitor) return '';
		return parsed.token || parsed.visitor_token || '';
	} catch {
		return '';
	}
};

export const isLoginApp = (toLogin: boolean = true, _store?: any) => {
	if (isMiniProgram) return false;
	const isEmbedded = isInWebCommunity();
	const isLoggedIn = Boolean(getTokenValue('docoiToken') || (!isEmbedded && getTokenValue(COMMUNITY_TOKEN_STORAGE_KEY)));
	if (!isLoggedIn && toLogin && !isEmbedded) {
		if (isInDocoiApp()) {
			JSBridge.call('login');
		} else {
			const { showLogin } = useLogin({
				onSuccess: () => window.location.reload()
			});
			showLogin({
				onSuccess: () => {
					window.location.reload();
				}
			});
		}
	}
	return isLoggedIn;
};

/**
 * 调用原生方法设置H5页面信息,跳转原生页面之前需要先传递当前页面信息用于埋点数据上报
 */
const setH5BeforeInfo = () => {
	try {
		let beforeInfos = getSessionStorage('beforeInfos') ? JSON.parse(getSessionStorage('beforeInfos')!) : [];
		let currentPageInfo = beforeInfos?.find((item: any) => item.fullPath == history.state.current)?.pageInfo;
		JSBridge.call('setH5BeforeInfo', currentPageInfo);
	} catch (e) {
		console.log('e', e);
	}
};

/**
 * 在app内跳转新页面打开链接, 原生跳转前会根据path前缀判断链接类型：
 * /immerse/ 跳转沉浸式页面
 * /mini/ 跳转小程序式页面
 * 其他的都是普通H5页面（顶部自带标题栏和返回）
 * @param params 更新参数
 */
export function openLink(params: { link: string }) {
	setH5BeforeInfo();
	JSBridge.call('openLink', params);
}

/**
 * 跳转原生页面
 * @param params 更新参数
 */
export const redirectPage = (params: { page: JSBridgePageType; params?: any }, callback?: CallbackFunction) => {
	setH5BeforeInfo();
	if (params?.page === 6 || params?.page === 1) {
		params.params = { ...params?.params, tab: params?.params?.tab || 0 };
	}
	JSBridge.call('redirectPage', params, callback);
};

export const toBindGameRole = (params: { gameName: string; serverId: string }) => {
	JSBridge.call('pointsMallBindGame', params);
};
